import {AuthConfig} from "angular-oauth2-oidc";

const APP_ROOT = document.baseURI; // ex: https://.../AFI-MAIN/AFI_HOME_APP/

//Représente la configuration de l’authentification
export const authentificationConfiguration: AuthConfig = 
{
  responseType: "code",
  scope: "openid profile email",
  redirectUri: `${APP_ROOT}callback`,
  postLogoutRedirectUri: APP_ROOT,
  useSilentRefresh: true,
  silentRefreshRedirectUri: `${APP_ROOT}silent-check-sso.html`,
  timeoutFactor: 0.80,
  requireHttps: window.location.protocol === 'https:',
  strictDiscoveryDocumentValidation: true,
  showDebugInformation: true
};
